
import { useTranslation } from "react-i18next";
import NewPage from "../../../layouts/page/NewPage";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useState } from "react";
import { convertBooleanToStatus } from "../../../../utils/ConverterUtils";
import MenuConfig from "../../../../constants/MenuConfig";
import Form from "./Form";
import { getId, sendToApi } from "../../../../utils/ApiUtils";
import { useNavigate } from "react-router-dom";
import Api from "../../../../constants/Api";
import axiosInstance from "../../../../services/AxiosInstance";
import { ApiError } from "../../../components/Common/ApiError";

const GroupNew = () => {

    const { t } = useTranslation();
    const [status, setStatus] = useState(true);
    const [entityData, setEntityData] = useState(null);
    const navigate = useNavigate();
    const [selectedPermissions, setSelectedPermissions] = useState([]);
    const [selectedMenuPermissions, setSelectedMenuPermissions] = useState([]);
    const [reset, setReset] = useState(false);

    // Define o schema de validação do form.
    const formSchema = Yup.object().shape({
        name: Yup.string()
            .min(3, t("validation.min.generic", { field: t('name'), qty: 3 }))
            .required(t('validation.required.name'))
    });

    const onReset = () => {
        formik.resetForm({
            values: {
                name: ''
            }
        });
        setStatus(true);
        setSelectedPermissions([]);
        setSelectedMenuPermissions([]);
        setReset(previous => !previous);
    };

    // Define o formik.
    const formik = useFormik({
        initialValues: {
            name: ''
        },
        validationSchema: formSchema,
        onSubmit: values => {
            let payload = {
                id: getId(entityData),
                name: values.name,
                status: convertBooleanToStatus(status)
            }

            // Aciona a api
            sendToApi(Api.identity.group, payload, (resp) => {
                let id = entityData ? entityData.id : resp.data.id;

                // Faz uma nova chamada para atualizar as permissões.
                Promise.all([
                    axiosInstance.patch(`${Api.identity.group_permission}/group/${id}`, selectedPermissions),
                    axiosInstance.patch(`${Api.identity.group_menu_permission}/group/${id}`, selectedMenuPermissions)
                ])
                .catch(error => ApiError(error))
                .finally(() => {
                    if (entityData === null) {
                        onReset();
                    } else {
                        navigate(MenuConfig.identity.group.route);
                    }
                });
            }, (error) => {
                ApiError(error);
                formik.setSubmitting(false);
            });
        },
    });

    // Valida o form e em seguida submete os dados. Aciona o onSubmit do formik.
    const onSubmit = (e) => {
        e.preventDefault();
        formik.handleSubmit();
    }

    return (
        <>
            <NewPage
                motherMenu={t('identity')}
                childMenu={t('groups')}
                activeMenu={t('new')}
                child={<Form
                            formik={formik} status={status}
                            setStatus={setStatus} entityData={entityData}
                            setSelectedPermissions={setSelectedPermissions}
                            setSelectedMenuPermissions={setSelectedMenuPermissions}
                            reset={reset} />}
                setEntityData={setEntityData}
                path={Api.identity.group}
                isSubmitting={formik.isSubmitting}
                handleSubmit={onSubmit}
                cancelRoute={MenuConfig.identity.group.route}
            />
        </>
    );
}

export default GroupNew;
